import { render } from "./MasterclassClub.vue?vue&type=template&id=5b366d7a&scoped=true"
import script from "./MasterclassClub.vue?vue&type=script&lang=js"
export * from "./MasterclassClub.vue?vue&type=script&lang=js"

import "./MasterclassClub.vue?vue&type=style&index=0&id=5b366d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b366d7a"]])

export default __exports__